module.exports = __webpack_public_path__ + "/56ba8cdf5d156ea785dc2ef4fb882613.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/api/white-labeling/assets/your_logo.png
 ** module id = 1281
 ** module chunks = 0
 **/